import React from 'react';
import { Radio, Select, Input, InputNumber, Row, Col, message, Icon, Tooltip } from 'antd'
import { InputType, WidthType } from './input-const';

const RadioGroup = Radio.Group;

//最小宽度
const minWidth = 1;


class SettingInputNumber extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            feature: '', //原参数json字符串
            width: minWidth, //设置的宽度值，初始为最小宽度值
            featureParams: {
                name: '数字输入框组件',
                type: InputType.INPUTNUMBER, //控件类型，必须有此属性，用于渲染时期判断控件类型
                widthType: WidthType.DEFAULT, //宽度类型：自适应'default'、百分比'relative'、固定值'fixed'
                widthStr: '', //input宽度值               
                required: false, //是否必须
                defaultValue: '', //默认值
                size: 'default', //输入框大小
                step:'1',  //步长
                max:'',   //最大值
                min:'',    //最小值
                validationValueType: 'number'
            },

        }
    }

    static defaultProps = {
        initFeature: ''
    }

    //在渲染前调用,可在此最后一次初始化组件状态
    componentWillMount() {
        //将输入控件配置参数设置到状态中
        if (this.props.initFeature) {
            try {
                let initFeature = JSON.parse(this.props.initFeature);
                if (initFeature.type == InputType.INPUTNUMBER) {
                    let { widthType , widthStr = '', size = '', step = '',max = '', min = '', required = false,
                        defaultValue = '' } = initFeature;
                    let width = '';

                    if (widthType == WidthType.RELATIVE) {
                        width = widthStr.replace('%', '');
                    } else if (widthType == WidthType.FIXED) {
                        width = widthStr.replace('px', '');
                    }
                    const fp = { ...this.state.featureParams };
                    fp.widthType = widthType;
                    fp.widthStr = widthStr;
                    fp.size = size;
                    fp.step = step;
                    fp.max = max;
                    fp.min =min;
                    fp.required = required;
                    fp.defaultValue = defaultValue;
                    this.setState({
                        feature: this.props.initFeature,
                        width: width,
                        featureParams: fp
                    });
                }

            } catch (e) {
                console.log(e);
                message.error('解析控件配置参数出错！');
            }
        } else {
            try {
                let feature = JSON.stringify(this.state.featureParams);
                this.setState({
                    feature: feature
                });
            } catch (e) {
                console.log(e);
                message.error('生成控件配置参数出错！');
            }
        }
    }

    //供父组件获取feature
    getFeature = () => {
        return this.state.feature;
    }

    //切换输入框大小类型radio时回调，清空之前的值
    handleSizeRadioChange = (e) => {
        let size = e.target.value;
        const fp = { ...this.state.featureParams };
        fp.size = size;

        this.setState({
            featureParams: fp
        });
        this.createFeature(fp);
    }

    //生成feature参数json字符串
    createFeature = (featureParams) => {
        try {
            let feature = JSON.stringify(featureParams);
            this.setState({
                feature: feature
            });
            this.props.onChange(feature);
        } catch (e) {
            console.log(e);
            message.error('生成控件配置参数出错！');
        }
    }

    //切换宽度类型radio时回调，清空之前的值
    handleWidthRadioChange = (e) => {
        let widthType = e.target.value;

        const fp = { ...this.state.featureParams };
        fp.widthType = widthType;
        fp.widthStr = '';

        this.setState({ width: '', featureParams: fp });
        this.createFeature(fp);
    }

    //是否必填
    handleRequiredRadioChange = (e) => {
        let required = e.target.value;

        const fp = { ...this.state.featureParams };
        fp.required = required;

        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //宽度值改变的时候，同步更新状态参数
    handleWidthChange = (value) => {
        let widthStr;
        let widthType = this.state.featureParams.widthType;

        if (widthType == WidthType.RELATIVE) {
            widthStr = value + '%';
        } else if (widthType == WidthType.FIXED) {
            widthStr = value + 'px';
        } else {
            widthStr = '';
        }

        const fp = { ...this.state.featureParams };
        fp.widthStr = widthStr;

        this.setState({ width: value, featureParams: fp });
        this.createFeature(fp);
    }

    //当输入默认值改变时
    handleDefaultValueChange = (value) => {
        const fp = { ...this.state.featureParams };
        fp.defaultValue = value ? value : '';;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //步长值改变的时候，同步更新状态参数
    handleNumberLimitChange = (value) =>{
        const fp = { ...this.state.featureParams };
        fp.step = value;
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //最大值改变的时候，同步更新状态参数
    handleMaxNumberChange = (value) => {
        const fp = { ...this.state.featureParams };
        fp.max = value ? value : '';
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }

    //最小值改变的时候，同步更新状态参数
    handleMinNumberChange = (value) => {
        const fp = { ...this.state.featureParams };
        fp.min = value ? value : '';
        this.setState({ featureParams: fp });
        this.createFeature(fp);
    }


    render() {

        let width = this.state.width;
        let { widthType, required, defaultValue, size, step, max, min } = this.state.featureParams;

        return (
            <div id="input-setting-div">
                <Row type="flex">
                    <Col>
                        <div style={{ margin: "16px 0" }}>宽度</div>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <RadioGroup onChange={this.handleWidthRadioChange} name="widthradiogroup"
                            value={widthType}>
                            <Radio value={WidthType.DEFAULT}>
                                自适应
                            </Radio>
                            <Radio value={WidthType.RELATIVE}>
                                百分比
                            </Radio>
                            <Radio value={WidthType.FIXED}>
                                固定宽度
                            </Radio>
                        </RadioGroup>
                    </Col>
                    <Col>
                        {
                            widthType == WidthType.RELATIVE ?
                                <InputNumber size="small"
                                    min={minWidth}
                                    formatter={value => `${value}%`}
                                    parser={value => value.replace('%', '')}
                                    onChange={this.handleWidthChange}
                                    value={width} />
                                : (
                                    widthType == WidthType.FIXED ?
                                        <InputNumber size="small"
                                            min={minWidth}
                                            formatter={value => `${value}px`}
                                            parser={value => value.replace('px', '')}
                                            onChange={this.handleWidthChange}
                                            value={width} />
                                        : null
                                )
                        }
                    </Col>
                </Row>
            {/*     <Row type="flex">
                    <Col>
                        <div style={{ margin: "16px 0" }}>是否必填</div>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <RadioGroup onChange={this.handleRequiredRadioChange} name="requiredradiogroup"
                            value={required}>
                            <Radio value={false}>
                                非必填
                            </Radio>
                            <Radio value={true}>
                                必填
                            </Radio>
                        </RadioGroup>
                    </Col>
                </Row> */}
                <Row type="flex">
                    <Col span={24}>
                        <div style={{ margin: "16px 0" }}>最大值 | 最小值</div>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col span={12}>
                        <InputNumber min={1} value={max} style={{ width: '60%' }} placeholder="请输入最大值" onChange={this.handleMaxNumberChange}/>
                    </Col>
                    <Col span={12}>
                        <InputNumber min={1} value={min} style={{ width: '60%' }} placeholder="请输入最小值" onChange={this.handleMinNumberChange}/>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <div style={{ margin: "16px 0" }}>步长 <Tooltip title={'即每次增加或递减的大小'} placement='top' ><Icon type="question-circle" /></Tooltip></div>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col span={12}>
                        <InputNumber min={0} style={{ width: '60%' }} placeholder="请输入步长" onChange={this.handleNumberLimitChange} value={step} />
                    </Col>
                </Row>
                <Row type="flex">
                    <Col>
                        <div style={{ margin: "16px 0" }}>输入框大小</div>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col style={{ align: "center" }}>
                        <RadioGroup value={size} onChange={this.handleSizeRadioChange}>
                            <Radio value={'large'}>
                                大
                    </Radio>
                            <Radio value={'default'}>
                                默认
                    </Radio>
                            <Radio value={'small'}>
                                小
                    </Radio>
                        </RadioGroup>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col >
                        <div style={{ margin: "16px 0" }}>默认值</div>
                    </Col>
                </Row>
                <Row type="flex">
                    <Col span={12}>
                        <InputNumber placeholder="请输入默认值" min={1}  style={{ width: '60%' }} onChange={this.handleDefaultValueChange} value={defaultValue} />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default SettingInputNumber;


// WEBPACK FOOTER //
// ./components/common/NHInputPicker/setting-inputNumber.js